<template>
	<div>
		<j-card class="mb2">
			<j-accordion colorWhenClosed="bg0">
				<div slot="title" class="fs4 fw7">{{ $t("associated_contracts") }}</div>
				<!-- Body -->
				<j-card
					slot="body"
					v-for="(item, i) in computedList"
					:key="i"
					class="flex xs-middle bg5 p4"
				>
					<div class="xs-6">
						<router-link
							:to="{ name: 'BindersUpdate', params: { id: item.binderId } }"
							>{{ item.binderNumber ? item.binderNumber : "---" }}</router-link
						>
					</div>
					<div class="flex xs-right xs-6" v-if="showButtons">
						<crm-icon
							class="cu2"
							name="delete"
							color="cError"
							@click.native="$emit('binders:remove', item.id)"
						/>
					</div>
				</j-card>

				<!-- No data -->
				<j-card
					slot="body"
					v-if="list && !list.length"
					class="bg5 p2 ta2 fs3"
					>{{ $t("errors.no_data") }}</j-card
				>

				<!-- Add button -->
				<div slot="body" class="xs-12 flex xs-right p2" v-if="showButtons">
					<j-button size="xsmall" @click="$emit('binders:open_modal')">{{
						$t("add")
					}}</j-button>
				</div>
			</j-accordion>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JAccordion from "@/components/JAccordion"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

export default {
	components: { JCard, JButton, CrmIcon, JAccordion },

	props: {
		list: Array,
		showButtons: {
			type: Boolean,
			default: true
		}
	},

	computed: {
		computedList() {
			return (
				this.list?.map(item => ({
					id: item.id,
					binderId: item?.contract?.id,

					// HACK: we have this binderNumber defined as fact even though it's iportant to be displayed
					// We agreed on this with Bambi that we have it as fact
					binderNumber: item?.contract?.facts?.find(
						fact => fact.type === "binderNumber"
					)?.value?.stringValue
				})) || []
			)
		}
	}
}
</script>
